<div class="header-container">
  <div class="header-logo-wrapper">
    @if (currentEvent | async; as event) {
      <div class="header-dates">{{ getDateRange(event.startDate, event.endDate) }}</div>
    }
    <div class="header-logo-wrapper-inner">
      <img
        class="header-logo"
        src="assets/imgs/logo.svg"
        alt="logo"
        [routerLink]="['/home']"
      />

      @if (!closeDisplayed) {
      <div class="mobile-only mobile-header-actions">
        <a href="https://shop.wirefestival.com/" target="_blank" class="header-action-item mobile-story">
          <img src="assets/imgs/story.svg" alt="story-icon" />
          STORE
        </a>
        <!-- <a href="https://ra.co/events/2268043" target="_blank" class="header-action-item mobile-tickets">
          <img src="assets/imgs/tickets.svg" alt="ticket-icon" />
          TICKETS
        </a> -->
      </div>
      } @else {
        <img
          routerLink="home"
          class="close-button"
          src="assets/imgs/close-button.svg"
          alt="close-icon"
        />
      }
    </div>
  </div>

  <div class="header-actions">
    <div
      class="header-action-item"
      [routerLink]="['home']"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      HOME
    </div>
    @if (currentEvent | async; as event) {
      @if (event?.isLineupPublic) {
        <div class="header-action-item" [routerLink]="['lineup/list']" routerLinkActive="active">
          LINEUP
        </div>
      }
      @if (event?.isSchedulePublic) {
        <div class="header-action-item" [routerLink]="['schedule/all']" routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }">SCHEDULE</div>
      }
    }
    <!-- <div class="header-action-item" [routerLink]="['instalations']" routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }">INSTALLATIONS</div> -->
    <div
      class="header-action-item"
      [routerLink]="['history/list']"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      HISTORY
    </div>
    <div
      class="header-action-item"
      [routerLink]="['info']"
      routerLinkActive="active"
    >
      INFO+
    </div>

    <!-- <div
      class="header-action-item"
      [routerLink]="['opencall']"
      routerLinkActive="active"
    >
      OPEN CALL
    </div> -->

    <a href="https://shop.wirefestival.com/" target="_blank" class="header-action-item story">
      <img src="assets/imgs/story.svg" alt="story-icon" />
      STORE
    </a>
    <!-- <div>
      <a href="https://ra.co/events/2268043" target="_blank" class="header-action-item tickets">
        <img src="assets/imgs/tickets.svg" alt="ticket-icon" />
        TICKETS
      </a>
    </div> -->

    @if (currentUser | async; as user) {
      <div
        class="header-action-item header-user"
        [routerLink]="[user?.isProfileCompleted ? '/profile/details' : '/profile/user/personal']"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }"
      >
        <img src="assets/imgs/profile.svg" alt="profile" class="header-user-icon" />
        HELLO, {{ user?.fullName | uppercase }}
      </div>
    } @else {
      <div
        class="header-action-item"
        [routerLink]="['/login']"
        routerLinkActive="active"
      >
        LOGIN
      </div>
    }

    <!-- <div
      class="header-action-item-link"
      [routerLink]="['tickets']"
      routerLinkActive="active"
      target="_blank"
    >
      <button class="header-action-item tickets">
        <img src="assets/imgs/tickets.svg" alt="ticket-icon" />
        TICKETS
      </button>
    </div> -->
  </div>
</div>
